import { Button, Img, List, Text } from "components";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import MyCustomCakesCustomcakecard from "./MyCustomCakesCustomcakecard";
import { useEffect, useState } from "react";
import globalRequest from "../../../../utils/global/globalRequest";
import { useDispatch, useSelector } from "react-redux";
import { changeLoader } from "../../../../redux/reducers/loader";
import * as CUSTOM from "../../../../utils/helper/custom";
import * as APIS from "../../../../utils/helper/Enum";
import { setSnackbar } from "../../../../redux/reducers/snackbar";
import EmptyAll from "pages/EmptyList";
import { currentTrigger } from "redux/reducers/trigger";
import {
  addDeleteGetLocalStorage,
  storageKeys,
} from "../../../../utils/global/localData";
import { useAppFont } from "utils/helper/useAppFont";

const MyCustomCake = (prop) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const triggerValue = useSelector(currentTrigger);
  const dispatch = useDispatch();
  const [list, setList] = useState([]);
  const [apiStatus, setApiStatus] = useState(false);
  const {interClass, headingClass, interFamily, headingFamily} = useAppFont();

  /**
   * get question list
   */
  const getMyCakeList = async () => {
    try {
      dispatch(changeLoader(true));
      let response = await globalRequest(
        `${APIS.CUSTOMCAKE.MY_LIST}`,
        "get",
        {},
        { params: { page: 1, limit: 20000 } },
        true
      );
      response = response?.data; 
      if (response?.status == "SUCCESS") {
        setList(response?.data?.data);
      } else {
        dispatch(
          setSnackbar({
            snackbarOpen: true,
            snackbarMessage: response?.message,
            snackbarState: "error",
          })
        );
      }
    } catch (e) {
      dispatch(
        setSnackbar({
          snackbarOpen: true,
          snackbarMessage: e?.message,
          snackbarState: "error",
        })
      );
    }
    dispatch(changeLoader(false));
    setApiStatus(true);
  };

  useEffect(() => {
    addDeleteGetLocalStorage(storageKeys.ORDER_TAB, {}, "delete");
    getMyCakeList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (triggerValue == "getCustomCakeList") {
      getMyCakeList();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [triggerValue]);

  return (
    <>
      <div className="flex flex-row font-nunitomedium items-center justify-between w-full mb-7 xs:flex-wrap xs:gap-4">
        <h2 className={`text-[24px] leading-[32px] sm:text-[20px] sm:leading-[28px] font-semibold text-center text-[var(--Blacks-900,#1A1A1A)] ${interClass}`}>
          {t("customCake")}
        </h2>
        {list.length > 0 && (
          <Button
            className="flex h-[48px] min-w-[125px] items-center justify-center gap-[10px]
                      px-[24px] py-[12px]
                      rounded-[360px]
                      border border-[#E6E6E6]
                      bg-[white]
                      ltr:ml-auto rtl:mr-auto"
            size="md"
            hover={true}
            hoverclass="bg-gray-100"
            onClick={() => navigate('/design-my-cake')}
          >
            <Text
              as="span"
              className="mx-2 text-center text-[14px] font-medium leading-[20px] text-[#1A1A1A]"
              style={{ fontFamily: headingFamily }}
            >
              {t("designCake")}
            </Text>
          </Button>
        )}
      </div>

      {list.length > 0 ? (
        <div className="flex flex-col gap-4 w-full">
          {list.map((items, index) => {
            return (
              <div key={"cake-items" + index} className="w-full">
                <MyCustomCakesCustomcakecard
                  setValue={prop?.setValue}
                  className=""
                  data={items}
                  userimage={
                    items?.imageLinks.length > 0
                      ? `${CUSTOM.getValidImage(items?.imageLinks[0])}`
                      : "images/default.png"
                  }
                  esttime="Est. Time :"
                  esttime1={`${CUSTOM.minutsToHour(items?.prepTime)} hrs`}
                  estprice="Est. Price :"
                  estprice1={`SAR ${CUSTOM.setPrice(items?.price)}`}
                  buttontext={t("placeOrder")}
                />
              </div>
            );
          })}
        </div>
      ) : null}
      {apiStatus && list.length == 0 ? <EmptyAll type="custom-cake" /> : null}
    </>
  );
};

export default MyCustomCake;
